// Which hosting site is serving this page.
//
// This has to be decided at runtime from the hostname, not at build time:
// when no PR is promoted, the dev (staging) site is a byte-for-byte clone of
// production's release, so the same bundle runs on both.
const STAGING_SITE = "triptracker-dev";

export function isStagingHost(hostname: string): boolean {
  const host = hostname.toLowerCase();
  // Live channel (triptracker-dev.web.app / .firebaseapp.com) and any
  // preview channel on the dev site (triptracker-dev--<channel>.web.app).
  return host.startsWith(`${STAGING_SITE}.`) || host.startsWith(`${STAGING_SITE}--`);
}

export const IS_STAGING =
  typeof window !== "undefined" && isStagingHost(window.location.hostname);
